<template>
  <label>Fecha</label>
  <div class="fechas">
    <div
      v-for="fecha in fechas"
      class="boton-fecha"
      :class="{ selected: fecha == fechaSelected }"
      @click="selectFecha(fecha)"
    >
      <div>{{ getDayLetters(fecha) }}</div>
      <div class="fs-big">{{ getDay(fecha) }}</div>
    </div>
  </div>
</template>
<script setup>
import { getDay, getDayLetters } from "@/helpers"
const props = defineProps({
  fechas: {
    type: Array,
    required: true,
  },
  fechaSelected: {
    type: String,
  },
})

const emit = defineEmits({ select: "String" })
const selectFecha = (fecha) => {
  emit("select", fecha)
}
</script>
<style>
.fechas {
  display: flex;
  justify-content: space-between;
  text-align: center;
}

.boton-fecha {
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #000000;
  width: 76px;
  height: 70px;
  background-color: #ffffff;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #ffffff;
}

.selected {
  color: #ffffff;
  background-color: #1a9bfa;
  box-shadow: 0px 3px 6px #a8a8a829;
}
</style>
